export enum Role {
  RECAP_USER = 'FR-LM-ROLE-RECAP-USER-ACCESS',
  SUPPLIER_USER = 'FR-LM-ROLE-RECAP-SUPPLIER-ACCESS'
}
